{
  "primer": {
    "eyebrow": "Namaz vakitleri ve Kıble",
    "headline": "Rhemn, namaz vakitleri ve Kıble için konumunuza ihtiyaç duyar.",
    "body": "Bunu yalnızca namaz vakitleriniz, Kıble yönü ve yerel hava durumu için kullanırız — başka hiçbir şey için değil.",
    "cta": "Devam et",
    "skip": "Şimdi değil",
    "skip_body": "Namaz vakitleri ve Kıble kapalı kalacak."
  }
}
